import styled, {keyframes, css} from 'styled-components';
import {textSizes} from '@stencil/build-theme';

// Optimized shimmer animation using transform instead of background-position
const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const SalesCampaignMainWrapper = styled.div``;

// Wrapper for the entire component
export const SalesCampaignWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

// Background image
export const SalesCampaignBackGroundImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 0.8rem;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0; /* Ensures it stays behind content */
`;

// Card content wrapper
export const CardWrapper = styled.div<{$showShimmer?: boolean; $noBackground?: boolean}>`
  padding: 1.2rem 1.5rem;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  gap: 1.8rem;
  border: 0.1rem solid #e4e4e4;
  position: relative;
  z-index: 1; /* Ensures it stays above the background image */

  /* Use transform3d to force GPU acceleration */
  transform: translate3d(0, 0, 0);
  /* Reduce repaints by using background-color instead of background shorthand */
  background-color: ${props => (props.$noBackground ? 'white' : 'transparent')};

  /* Enable GPU acceleration */
  will-change: transform, opacity;
  transform: translateZ(0);

  &::after {
    ${props =>
      props.$showShimmer &&
      css`
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        animation: ${shimmer} 1.2s linear infinite;
        background: transparent;
        background-size: 100% 100%;
        background-image: linear-gradient(
          to right,
          transparent 0%,
          #edeef180 20%,
          transparent 40%,
          transparent 100%
        );
        top: 0;
        left: 0;
        pointer-events: none;

        /* Hardware acceleration */
        will-change: transform, opacity;
        transform: translate3d(0, 0, 0);
      `}
  }
`;

// Main image
export const MainImg = styled.img`
  width: 8.6rem;
  height: 6.6rem;
  flex-shrink: 0;
`;

// Wrapper for the text section
export const RightWrapper = styled.div``;

// Header/title text
export const Header = styled.h5`
  ${textSizes.BaseW3};
  color: ${props => props.color || 'black'};
  margin-bottom: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

// Wrapper for description and toggle
export const DescWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

// Description text
export const Desc = styled.p`
  ${textSizes.SmallW1};
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;
